import { __rest } from "tslib";
import React from 'react';
import { Plus } from '@gravity-ui/icons';
import { Button, Icon, Text } from '@gravity-ui/uikit';
import isObjectLike from 'lodash/isObjectLike';
import set from 'lodash/set';
import { Controller, transformArrIn, } from '../../../../core';
import { block, filterPropertiesForObjectInline } from '../../../utils';
import './ObjectBase.css';
const b = block('object-base');
export const ObjectBase = (_a) => {
    var { inline, spec, name, Layout } = _a, restProps = __rest(_a, ["inline", "spec", "name", "Layout"]);
    const addBtn = React.useMemo(() => {
        var _a;
        return (React.createElement(Button, { onClick: () => restProps.input.onChange(transformArrIn(spec.defaultValue) || {}), disabled: (_a = spec.viewSpec) === null || _a === void 0 ? void 0 : _a.disabled, qa: `${name}-init-obj` },
            React.createElement(Icon, { data: Plus, size: 14 }),
            spec.viewSpec.layoutTitle || null));
    }, [spec.defaultValue, spec.viewSpec.layoutTitle, restProps.input.onChange]);
    const parentOnChange = React.useCallback((childName, childValue, childErrors) => restProps.input.onChange((currentValue) => set(Object.assign({}, currentValue), childName.split(`${restProps.input.name}.`).join(''), childValue), childErrors), [restProps.input.onChange, restProps.input.name]);
    const content = React.useMemo(() => {
        if (!spec.properties ||
            !isObjectLike(spec.properties) ||
            !Object.keys(spec.properties || {}).length) {
            return null;
        }
        if (!inline && !restProps.input.value) {
            return addBtn;
        }
        const specProperties = inline
            ? filterPropertiesForObjectInline(spec.properties)
            : spec.properties;
        const delimiter = spec.viewSpec.delimiter;
        const orderProperties = spec.viewSpec.order || Object.keys(specProperties);
        return (React.createElement("div", { className: b('content', { inline }) }, orderProperties.map((property) => {
            var _a;
            return specProperties[property] ? (React.createElement(React.Fragment, { key: `${name ? name + '.' : ''}${property}` },
                React.createElement(Controller, { value: (_a = restProps.input.value) === null || _a === void 0 ? void 0 : _a[property], spec: specProperties[property], name: `${name ? name + '.' : ''}${property}`, parentOnChange: parentOnChange, parentOnUnmount: restProps.input.parentOnUnmount }),
                delimiter && delimiter[property] ? (React.createElement(Text, { className: b('delimiter') }, delimiter[property])) : null)) : null;
        })));
    }, [
        spec.properties,
        spec.viewSpec.delimiter,
        spec.viewSpec.order,
        restProps.input.value,
        restProps.input.parentOnUnmount,
        inline,
        addBtn,
        name,
        parentOnChange,
    ]);
    if (!Layout || !content) {
        return content;
    }
    return (React.createElement(Layout, Object.assign({ spec: spec, name: name }, restProps), content));
};
export const ObjectInline = (props) => {
    return React.createElement(ObjectBase, Object.assign({}, props, { inline: true }));
};
